import React, { useState, useEffect } from "react";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import SelectField from "../Shared/SelectField";
import Button from "../Shared/Button";
import { batchUpdatesPractitionerPreferences } from "../../services/practitioner";
import { fetchPractitionerPreferences } from "../appSlice";
import { selectActivePractitioners } from "../appSlice";

const STATES_IN_AUS = [
  { label: "NSW", value: "NSW" },
  { label: "QLD", value: "QLD" },
  { label: "SA", value: "SA" },
  { label: "TAS", value: "TAS" },
  { label: "VIC", value: "VIC" },
  { label: "WA", value: "WA" },
  { label: "ACT", value: "ACT" },
  { label: "NT", value: "NT" },
];

const PractitionerLocation = () => {
  const practitioners = useSelector(selectActivePractitioners);
  const dispatch = useDispatch();
  const practitionerPreferences = useSelector((state) => state.app.practitionerPreferences);
  const [preferenceUpdates, setPreferenceUpdates] = useState({});
  const [practitionerPreferencesDisplay, setPractitionerPreferencesDisplay] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setPractitionerPreferencesDisplay(practitionerPreferences);
  }, [practitionerPreferences, practitioners]);

  const handleStateChange = (practitionerId, state) => {
    const update = {
      address: {
        state,
      },
    };

    setPreferenceUpdates({
      ...preferenceUpdates,
      [practitionerId]: update,
    });
    let isHavePreference =
      practitionerPreferencesDisplay.findIndex((preference) => preference.practitionerId === practitionerId) >= 0;
    if (!isHavePreference) {
      setPractitionerPreferencesDisplay(
        practitionerPreferencesDisplay.concat([
          {
            practitionerId,
            ...update,
          },
        ])
      );
    } else {
      setPractitionerPreferencesDisplay(
        practitionerPreferencesDisplay.map((preference) => {
          if (practitionerId === preference.practitionerId) {
            return {
              ...preference,
              practitionerId,
              ...update,
            };
          }

          return preference;
        })
      );
    }
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    await batchUpdatesPractitionerPreferences(preferenceUpdates);
    dispatch(fetchPractitionerPreferences());
    setPreferenceUpdates({});
    setIsSubmitting(false);
  };

  return (
    <div className="columns">
      <div className="column is-two-thirds">
        <div className="menu-label">Practitioner Location</div>
        <div className="table-container clinic-communication-method">
          <table className="table is-fullwidth is-stripe is-hoverable is-size-7">
            <thead>
              <tr>
                <th>Practitioner Name</th>
                <th>State</th>
              </tr>
            </thead>
            <tbody>
              {practitioners.map((practitioner) => (
                <tr key={practitioner.practitionerId}>
                  <td>{`${practitioner.firstName} ${practitioner.lastName}`}</td>
                  <td>
                    <SelectField
                      options={STATES_IN_AUS}
                      onChange={(e) => handleStateChange(practitioner.practitionerId, e.target.value)}
                      value={_.get(
                        practitionerPreferencesDisplay.find(
                          (preference) => preference.practitionerId === practitioner.practitionerId
                        ),
                        "address.state",
                        ""
                      )}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Button text="Submit" isLoading={isSubmitting} onClick={handleSubmit} />
      </div>
    </div>
  );
};

export default PractitionerLocation;
